import { Textarea } from '@commenda/kakashi';
import { useFormField } from '../../hooks/useFormField';
import type { ValidationRules } from '@commenda/types';
import { LabelWithGuidanceTooltip } from './LabelWithGuidanceTooltip';

export const TextAreaComponent = ({
  fieldId,
  label,
  description,
  placeholder,
  props = {
    rows: 4,
    maxLength: 1000,
    showCharCount: false,
  },
  guidance,
  validation,
}: {
  fieldId: string;
  label: string;
  description?: string;
  placeholder: string;
  props?: {
    rows: number;
    maxLength: number;
    showCharCount: boolean;
    disabled?: boolean;
  };
  guidance?: { text?: string };
  validation?: {
    rules?: ValidationRules;
    triggers?: string[];
  };
}) => {
  const { rows = 4, maxLength = 1000, showCharCount = false } = props || {};
  const { value, error, disabled, isRequired, setValue } = useFormField<string>(
    fieldId,
    {
      rules: validation?.rules,
      disabledFromProps: props?.disabled,
    }
  );
  const stringValue = value || '';

  return (
    <div className="mb-4" data-field-id={fieldId}>
      {(label || description) && (
        <LabelWithGuidanceTooltip
          label={label}
          guidance={guidance?.text}
          isRequired={isRequired}
          description={description}
        />
      )}
      <Textarea
        value={stringValue}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        error={error}
        disabled={disabled}
      />
      {showCharCount && (
        <p className="mt-1 text-sm text-text-tertiary">
          {stringValue.length}/{maxLength} characters
        </p>
      )}
    </div>
  );
};
